import JourneyOfferList from '@/components/purchase/journey/JourneyOfferList';
import { getManageFlowBookingById } from '@/features/manage/manageActions';
import {
  setSelectedOutboundOfferMapByLegId,
  startExchange,
  updateSelectedOutboundOfferMapByLegId,
} from '@/features/purchase/purchaseActions';
import {
  inboundDataSelector,
  outboundDataSelector,
  selectedOutboundOfferMapSelector,
} from '@/features/purchase/purchaseSelectors';
import { useBookingCreation } from '@/hooks/useBookingCreation';
import { useChangeBookingSelection } from '@/hooks/useChangeBookingSelection';
import { TransAlert } from '@/i18n/trans/alert';
import { TransText } from '@/i18n/trans/text';
import { useDispatch, useSelector } from '@/store/utils';
import type { ApiErrorResponse } from '@/types/api';
import { GTM_EVENT, trackCustomEvent } from '@/utils/gtm';
import { getDefaultOfferMap } from '@/utils/purchase';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const OutboundJourneyOfferList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const outboundData = useSelector(outboundDataSelector);
  const inboundData = useSelector(inboundDataSelector);
  const { handleCreatingAndFetchingTripOfferBooking } = useBookingCreation();
  const { hasSelection, booking: manageBooking } = useChangeBookingSelection();

  useEffect(() => {
    if (outboundData.selectedJourney) {
      dispatch(
        setSelectedOutboundOfferMapByLegId(
          getDefaultOfferMap(outboundData.selectedJourney)
        )
      );
    }
  }, [dispatch, outboundData.selectedJourney]);

  useEffect(() => {
    if (!outboundData.selectedJourney) {
      navigate('/purchase');
    }
  }, [navigate, outboundData.selectedJourney]);

  return (
    <JourneyOfferList
      title={<TransText i18nKey="selectOutboundTicket" />}
      selectedJourney={outboundData.selectedJourney}
      updateSelectedOfferMap={updateSelectedOutboundOfferMapByLegId}
      selectedOfferMapByLegIdSelector={selectedOutboundOfferMapSelector}
      onContinue={async () => {
        trackCustomEvent(GTM_EVENT.OUTBOUND_OFFER_CONFIRMED);
        if (inboundData.journeys) {
          return navigate('/purchase/inbound/journey');
        }

        if (hasSelection) {
          // Change-booking commit: create the exchange operation, refresh the
          // manage booking so it carries the new exchangeOperations[], then
          // enter checkout.
          try {
            await dispatch(startExchange()).unwrap();
            if (manageBooking?.id) {
              await dispatch(
                getManageFlowBookingById(manageBooking.id)
              ).unwrap();
            }
            navigate('/purchase/checkout');
          } catch (err) {
            const errors = (err as ApiErrorResponse).response?.data?.errors;
            if (errors?.length) {
              errors.forEach((e) => toast.error(e.message));
            } else {
              toast.error(<TransAlert i18nKey="startExchangeFailed" />);
            }
          }
          return;
        }

        handleCreatingAndFetchingTripOfferBooking();
      }}
      onGoBack={() => navigate(-1)}
    />
  );
};

export default OutboundJourneyOfferList;
